import { render, staticRenderFns } from "./AppSearchResultRecent.vue?vue&type=template&id=b4322d9e"
import script from "./AppSearchResultRecent.vue?vue&type=script&lang=js"
export * from "./AppSearchResultRecent.vue?vue&type=script&lang=js"
import style0 from "./AppSearchResultRecent.vue?vue&type=style&index=0&id=b4322d9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports